module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/~/json-loader!./.cache/json/index.json
// module id = 1056
// module chunks = 142629428675168